<div class="row">
  <div class="col-sm-9">
    <div class="booking_ht">
      <!-- <sm-title-bar pageTitle="All latest purchase"></sm-title-bar> -->
      <sm-title-bar pageTitle="All unpaid Bills/Invoices" [showBackToDashboard]="true"></sm-title-bar>
    </div>
  </div>
  <div class="col-sm-3">
  </div>
</div>


<div class="" *ngIf="!loader">
  <div class="row">
    <div class="col-md-6 col-sm-6 col-12" *ngFor="let data of unpaidInvoicesData">
    <div class="plan-card" style="position: relative; " (click)="openInvoice(data)">
      
      <div class="d-flex align-items-center" style="position: relative;flex-shrink: 0;">
      

        <!-- <div class="booking-initial" *ngIf="!data.image_thumb_url || data.image_thumb_url == 'null'">{{data.item_name.slice(0,1).toUpperCase()}}</div> -->
        <!-- <div class="booking-initial-img" style="position: relative; flex-shrink: 0;" *ngIf="data.image_thumb_url && data.image_thumb_url != 'null'">
          <img style="height: 50px;width: 50px;"  [src]="data.image_thumb_url" onerror="this.src='../../../../../assets/images/purchase-placeholder.jpeg'"
            alt="" class="img-fluid rounded-circle booking-initial-img">
          <span [ngStyle]="{backgroundColor: data.purchase_status == 2 ? 'yellow' : data.purchase_status == 1 ? 'green' : 'red' }" style="width: 15px; height:15px; display: block;position: absolute;    
           bottom: 0px;
    right: 0px; border-radius: 50%; background-color: red"></span>
        </div> -->
        <div class="m-2 data_list_r">
          <h2 class="plan-title"> {{ data.invoiceNumber }}</h2>
          <p class="plan-info">
            <span class="valueque"> Amount: {{data.i_amt}}, Due: {{data.i_due }}</span>
          </p>
        </div>
      </div>
      <!-- <p class="plan-cost my-3">
        <span class="value"></span> 
      </p> -->
      <p class="plan-cost">
        <span class="value">{{ data.customer_name }}, {{ data.cust_phone}}</span> 
      </p>
      <p class="plan-cost">
        <span class="value">{{ data.entity_name }}</span> 
      </p>
      <p><span class="label addr">{{ data.entity_address}} </span></p>
      <p class="plan-cost">
        <span class="value">{{ data.creation_time | date}}</span>
      </p>
    </div>
  </div>
  </div>
</div>


<!-- 
<mat-card appearance="outlined" *ngIf="!loader && latestPurchaseData.length > 0">
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [showImageColumn]="true" [imageTemplate]="image"
      [dataSource]="latestPurchaseData" [showPagination]="true" [itemsPerPage]="25">
    </sm-data-table>
  </div>
</mat-card>
<ng-template #menuTemplate let-rowvalue>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">check_circle</mat-icon>
    <span>Edit</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">timer</mat-icon>
    <span>Delete</span>
  </button>
</ng-template>
<ng-template #image let-objValue>
  <img [src]="
          objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
            ? objValue['image_thumb_url']
            : './assets/images/salon_support_header.png'
        " class="img-fluid rounded-circle" />
</ng-template> -->